'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';

import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const coachManagementModule = angular
  .module('app.coachManagement', [])
  .config(coachManagementConfig);

coachManagementConfig.$inject = ['$routeProvider'];

function coachManagementConfig($routeProvider) {
  $routeProvider
    .when('/coach-list', {
      template: '<ngz-coach-list list-mode="NUTRITION"></ngz-coach-list>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Coaches', icon: NAVIGATION_ICON.ASSIGNMENT_IND }
        ]
      }
    })
    .when('/coach-list/scan-iq', {
      template: '<ngz-coach-list list-mode="SCAN_IQ"></ngz-coach-list>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          { label: 'Staff Members', icon: NAVIGATION_ICON.ASSIGNMENT_IND }
        ]
      }
    })
    .when('/nutrition/coach-setup', {
      template: '<ngz-coach-setup></ngz-coach-setup>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Coach Setup', icon: NAVIGATION_ICON.ASSIGNMENT_IND }
        ]
      }
    })
    .when('/scan-iq/coach-setup', {
      template: '<ngz-coach-setup></ngz-coach-setup>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          { label: 'Staff Member Setup', icon: NAVIGATION_ICON.ASSIGNMENT_IND }
        ]
      }
    })
    .when('/coach-settings', {
      template: '<ngz-coach-settings-page></ngz-coach-settings-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Settings', icon: NAVIGATION_ICON.SETTINGS }
        ]
      }
    })
}
